import { AnyAction } from 'redux'
import * as actionType from './types'

export const showChangePostTonalModal = ({ post, list }: any): AnyAction => ({ type: actionType.SHOW_CHANGE_POST_TONAL_MODAL, payload: { post, list } })
export const closeChangePostTonalModal = (): AnyAction => ({ type: actionType.CLOSE_CHANGE_POST_TONAL_MODAL })
export const setChangePostTonalIsLoading = (value:any): AnyAction => ({ type: actionType.SET_CHANGE_POST_TONAL_IS_LOADING, payload: value })
